import { render, staticRenderFns } from "./SelectGame.vue?vue&type=template&id=beee81c2&scoped=true&"
import script from "./SelectGame.vue?vue&type=script&lang=js&"
export * from "./SelectGame.vue?vue&type=script&lang=js&"
import style0 from "./SelectGame.vue?vue&type=style&index=0&id=beee81c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beee81c2",
  null
  
)

export default component.exports